import { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { X } from 'lucide-react';

interface EmailShareProps {
  emails: string[];
  onAddEmail: (email: string) => void;
  onRemoveEmail: (email: string) => void;
}

export function EmailShare({ emails, onAddEmail, onRemoveEmail }: EmailShareProps) {
  const [newEmail, setNewEmail] = useState('');
  const [emailError, setEmailError] = useState<string | null>(null);

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleAddEmail = () => {
    if (!newEmail.trim()) {
      setEmailError("Email cannot be empty.");
      return;
    }

    if (!isValidEmail(newEmail.trim())) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    if (emails.includes(newEmail.trim())) {
      setEmailError("Email already shared.");
      return;
    }

    onAddEmail(newEmail.trim());
    setNewEmail('');
    setEmailError(null);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2"> {/* This is the missing part */}
        {emails.map((email) => (
          <div
            key={email}
            className="flex items-center gap-2 bg-secondary rounded-full px-3 py-1"
          >
            <span className="text-sm">{email}</span>
            <button
              onClick={() => onRemoveEmail(email)}
              className="text-muted-foreground hover:text-foreground"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div> {/* End of the missing part */}
      <div className="flex gap-2 px-1">
        <Input
          type="email"
          placeholder="Add email..."
          value={newEmail}
          onChange={(e) => {
            setNewEmail(e.target.value);
            setEmailError(null);
          }}
          className="flex-1"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddEmail();
            }
          }}
        />
        <Button onClick={handleAddEmail}>Share</Button>
      </div>
      {emailError && <p className="text-sm text-destructive">{emailError}</p>}
    </div>
  );
}
